import React, { useState, useEffect } from 'react';
import './Nav.css'; // Updated CSS file name
import logo from '../Images/sumukhalogo.png'; // Import the image
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const MyNavbar = () => {
  const location = useLocation(); // Track URL location changes

  useEffect(() => {
    const sectionId = location.hash;

    if (sectionId) {
      const sectionElement = document.querySelector(sectionId);
      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  const isActive = (path) => {
    return location.pathname === path ? 'active-nav-item' : '';
  };

  const [showDropdown, setShowDropdown] = useState(false);

  const handleMouseEnter = () => setShowDropdown(true);
  const handleMouseLeave = () => setShowDropdown(false);

  return (
    <div className="custom-header-container">
      <Navbar expand="lg" className="custom-navbar">
        <Container>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <Navbar.Brand className="d-flex align-items-center">
              <img src={logo} alt="Logo" className="custom-logo-img" />
              <div className="custom-brand-text mt-4">
                <h5>Sumukha Tax Filers</h5>
                <p className="custom-tagline">Simplifying Taxes Empowering Success</p>
              </div>
            </Navbar.Brand>
          </Link>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav" className="custom-navbar-spacing">
            <Nav className="custom-nav-links">
              <Link to="/" className={`custom-nav-item ${isActive('/')}`}>Home</Link>
              <Link to="/aboutus" className={`custom-nav-item ${isActive('/aboutus')}`}>About Us</Link>
             
              {/* Services Dropdown */}
              <NavDropdown
                title={
                  <span className={`custom-nav-item ${isActive('/individualservicespage') || isActive('/businessservicespage') ? 'active-nav-item' : ''}`}>
                    Services
                  </span>
                }
                id="services-dropdown"
                className="custom-nav-item"
                menuVariant="dark"
                show={showDropdown}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <Link to="/individualservicespage" className="dropdown-item">
                  Individual Services
                </Link>
                <hr />
                <Link to="/businessservicespage" className="dropdown-item">
                  Business Services
                </Link>
              </NavDropdown>

              <Link to="/referandearn" className={`custom-nav-item ${isActive('/referandearn')}`}>Refer and Earn</Link>
              <Link to="/price" className={`custom-nav-item ${isActive('/price')}`}>Pricing</Link>
              <Link to="/refundstatus" className={`custom-nav-item ${isActive('/refundstatus')}`}>Refund Status</Link>
              <Link to="/contact" className={`custom-nav-item ${isActive('/contact')}`}>Contact Us</Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default MyNavbar;
